(function () {
  const alreadyEngaged = sessionStorage.getItem("engaged_session_fired");
  if (!alreadyEngaged) {
    const onProductPage =
      location.pathname.includes("/products") ||
      location.pathname.includes("/collections");

    // --- PAGEVIEW COUNTER (must run always)
    let pageCount = Number(sessionStorage.getItem("session_page_count") || 0);
    pageCount += 1;
    sessionStorage.setItem("session_page_count", pageCount);

    // --- TIMER LOGIC
    let activeTime = 0;
    let timer;
    let timerInterval = 2000;

    function startTimer() {
      if (timer) return;
      timer = setInterval(() => {
        activeTime += timerInterval;
      }, timerInterval);
    }

    function stopTimer() {
      clearInterval(timer);
      timer = null;
    }

    // Track visibility
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") startTimer();
      else stopTimer();
    });

    startTimer();

    // --- SCROLL DEPTH
    let scrolledEnough = false;
    window.addEventListener(
      "scroll",
      () => {
        if (!scrolledEnough) {
          const depth =
            (window.scrollY + window.innerHeight) /
            document.documentElement.scrollHeight;
          if (depth >= 0.4) scrolledEnough = true;
        }
      },
      { passive: true }
    );

    let engagementInterval;

    // --- ENGAGEMENT LOGIC
    let engaged = false;

    function checkEngagement() {
      if (
        !engaged &&
        activeTime >= 30000 &&
        scrolledEnough &&
        Number(sessionStorage.getItem("session_page_count")) >= 3 &&
        onProductPage
      ) {
        engaged = true;
        sessionStorage.setItem("engaged_session_fired", "1");

        if (typeof gtag === "function") {
          gtag("event", "custom_engaged_session");
        }

        clearInterval(engagementInterval);
        stopTimer();
      }
    }

    engagementInterval = setInterval(checkEngagement, timerInterval);
  }
})();


(function () {
  const EVENT_NAME = "custom_engaged_session_x";

  // If already fired this session → stop.
  if (sessionStorage.getItem(EVENT_NAME)) return;

  // --- REQUIRE AT LEAST 2 PAGEVIEWS ---
  let pageviews = Number(sessionStorage.getItem("pageviews_v2") || 0);
  pageviews += 1;
  sessionStorage.setItem("pageviews_v2", pageviews);

  // --- SELECTORS TO TRACK ---
  const SELECTORS = [
    '#openModal',
    '.su__toggle',
    '.video__wrapper',
    '.calc__buttons'
  ];

  // Ensures event fires once
  function fireEventOnce() {
    if (sessionStorage.getItem(EVENT_NAME)) return;
    if (pageviews < 2) return; // Require 2+ pageviews

    sessionStorage.setItem(EVENT_NAME, "1");

    if (typeof gtag === "function") {
      gtag("event", EVENT_NAME);
    }
  }

  // Attach listeners to existing elements only
  function attachListeners() {
    SELECTORS.forEach((selector) => {
      const elements = document.querySelectorAll(selector);

      elements.forEach((el) => {
        el.addEventListener("click", fireEventOnce, { once: true });
      });
    });
  }

  attachListeners();
})();
